import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  TextareaAutosize,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import "../../css/App.scss";
import { theme } from "../../utilities/themes";
import { useContext, useEffect, useState } from "react";
import { SplashContext } from "../layout/layout";
import { MailOutline, PhoneOutlined } from "@mui/icons-material";
import seatBG from "../../images/jpg/seatBG.jpg";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";

const ContactUs = () => {
  //state
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const splashScreen = useContext(SplashContext);
  useEffect(() => {
    splashScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const props = {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    setEmail,
    phone,
    setPhone,
    message,
    setMessage,
  };
  return (
    <ThemeProvider theme={theme}>
      <Stack
        spacing={2}
        sx={{
          backgroundImage: !isMobile && `url(${seatBG})`,
          height: !isMobile && "95vh",
          backgroundSize: "cover",
        }}
      >
        {isMobile ? (
          <CardContent {...props} />
        ) : (
          <Container maxWidth="lg" sx={{ height: "100%" }}>
            <Stack justifyContent={"center"} width="100%" height={"100%"}>
              <Paper sx={{ width: "100%" }}>
                <CardContent {...props} />
              </Paper>
            </Stack>
          </Container>
        )}
      </Stack>
    </ThemeProvider>
  );
};
const CardContent = ({
  firstName,
  setFirstName,
  lastName,
  setLastName,
  email,
  setEmail,
  phone,
  setPhone,
  message,
  setMessage,
}) => {
  const isSM = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const spanFontSizes1 = {
    fontSize: { lg: "1.125rem", md: "1rem", sm: "0.875rem", xs: "0.875rem" },
  };
  const spanFontSizes2 = {
    fontSize: { lg: "1rem", md: "0.875rem", sm: "0.75rem", xs: "0.75rem" },
  };

  return (
    <Stack spacing={2} sx={{ p: 5 }}>
      <Typography
        variant="h4"
        color={theme.palette.primary.main}
        textTransform="uppercase"
        fontSize={{
          xs: "1.5rem",
          sm: "2.125rem",
        }}
      >
        Contact us
      </Typography>

      <ValidatorForm onSubmit={() => {}}>
        <Grid container>
          <Grid item xs={12} md={4}>
            <Stack spacing={3}>
              <Stack>
                <Typography
                  component="span"
                  textTransform={"uppercase"}
                  fontWeight={300}
                  sx={{ ...spanFontSizes2 }}
                >
                  First name *
                </Typography>
                <TextValidator
                  name="firstName"
                  value={firstName}
                  onChange={(event) => setFirstName(event.target.value)}
                  color="secondary"
                  size="small"
                  sx={{ width: "80%" }}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Stack>
              <Stack>
                <Typography
                  component="span"
                  textTransform={"uppercase"}
                  fontWeight={300}
                  sx={{ ...spanFontSizes2 }}
                >
                  Last name *
                </Typography>
                <TextValidator
                  name="lastName"
                  value={lastName}
                  onChange={(event) => setLastName(event.target.value)}
                  color="secondary"
                  size="small"
                  sx={{ width: "80%" }}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Stack>
              <Stack>
                <Typography
                  component="span"
                  textTransform={"uppercase"}
                  fontWeight={300}
                  sx={{ ...spanFontSizes2 }}
                >
                  Phone *
                </Typography>
                <TextValidator
                  name="phone"
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                  type="phone"
                  color="secondary"
                  size="small"
                  sx={{ width: "80%" }}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Stack>
              <Stack>
                <Typography
                  component="span"
                  textTransform={"uppercase"}
                  fontWeight={300}
                  sx={{ ...spanFontSizes2 }}
                >
                  Email *
                </Typography>
                <TextValidator
                  name="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  type="email"
                  color="secondary"
                  size="small"
                  sx={{ width: "80%" }}
                  validators={["required", "isEmail"]}
                  errorMessages={[
                    "this field is required",
                    "email is not valid",
                  ]}
                />
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs={12} md={8}>
            <Stack spacing={2} marginTop={isSM && 2}>
              <Stack>
                <Typography
                  component="span"
                  textTransform={"uppercase"}
                  fontWeight={300}
                  sx={{ ...spanFontSizes2 }}
                >
                  Message *
                </Typography>

                <TextareaAutosize
                  minRows={8}
                  maxRows={8}
                  value={message}
                  onChange={(event) => setMessage(event.target.value)}
                  style={{
                    borderColor: "rgb(200, 200, 200)",
                    borderRadius: 5,
                    fontFamily: "Roboto",
                    resize: "none",
                  }}
                  minLength={1}
                />
              </Stack>
              <Typography
                component="span"
                fontWeight={300}
                sx={{ ...spanFontSizes2 }}
              >
                All fields indicated with * are compulsory
              </Typography>
              <Stack direction="row-reverse">
                <Button variant="contained" type="submit" onSubmit={() => {}}>
                  Send
                </Button>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </ValidatorForm>

      <Stack
        direction={isMobile ? "column" : "row"}
        spacing={isMobile ? 2 : 5}
        sx={{ width: "70%" }}
      >
        <Stack direction={"row"} alignItems="center" spacing={2}>
          <IconBox>
            <MailOutline fontSize="small" htmlColor="white" />
          </IconBox>
          <Stack>
            <Typography component={"span"} sx={{ ...spanFontSizes1 }}>
              Email:
            </Typography>
            <Typography
              component={"span"}
              sx={{ ...spanFontSizes2 }}
              fontWeight={300}
            >
              partnerships@little.africa
            </Typography>
          </Stack>
        </Stack>
        <Stack direction={"row"} alignItems="center" spacing={2}>
          <IconBox>
            <PhoneOutlined fontSize="small" htmlColor="white" />
          </IconBox>
          <Stack>
            <Typography component={"span"} sx={{ ...spanFontSizes1 }}>
              Tel:
            </Typography>
            <Typography
              component={"span"}
              sx={{ ...spanFontSizes2 }}
              fontWeight={300}
            >
              0113138966
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export const IconBox = ({ children }) => {
  return (
    <Box
      sx={{
        bgcolor: theme.palette.primary.main,
        p: 1,
        borderRadius: 5,
        height: 20,
        width: 20,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "0px 1.5px 3px grey",
      }}
    >
      {children}
    </Box>
  );
};
export default ContactUs;
